import {
  VACATION_ERROR_CODE,
  VacationErrorCode
} from './vacation-api.constants';

export const VACATION_AVAILABILITY_MONTH_UNIT = 'month';
export const VACATION_AVAILABILITY_PLACEHOLDER_PREFIX =
  'vacation-availability-placeholder-';

export const VACATION_AVAILABILITY_CALENDAR_CONFIG = {
  DATE_FORMAT: 'YYYY-MM-DD',
  EMPTY_TEXT: '',
  FIRST_INDEX: 0,
  FIRST_ISO_WEEKDAY: 1,
  NEXT_MONTH_STEP: 1,
  NOT_FOUND_INDEX: -1,
  PREVIOUS_MONTH_STEP: -1
};

export const VACATION_AVAILABILITY_CALENDAR_KEY = {
  DAY_ADVISORY: 'VACATION_AVAILABILITY_DAY_ADVISORY',
  DAY_AVAILABLE: 'VACATION_AVAILABILITY_DAY_AVAILABLE',
  DAY_UNAVAILABLE: 'VACATION_AVAILABILITY_DAY_UNAVAILABLE',
  EMPTY: 'VACATION_AVAILABILITY_EMPTY',
  LOAD_ERROR: 'VACATION_AVAILABILITY_LOAD_ERROR'
};

export const VACATION_AVAILABILITY_ADVISORY_REASON_CODES: VacationErrorCode[] = [
  VACATION_ERROR_CODE.OVERLAP,
  VACATION_ERROR_CODE.BALANCE_EXCEEDED,
  VACATION_ERROR_CODE.SEASON_ALREADY_USED,
  VACATION_ERROR_CODE.CAPACITY_EXCEEDED
];

export const VACATION_AVAILABILITY_MONTH_KEYS = [
  'JANUARY',
  'FEBRUARY',
  'MARCH',
  'APRIL',
  'MAY',
  'JUNE',
  'JULY',
  'AUGUST',
  'SEPTEMBER',
  'OCTOBER',
  'NOVEMBER',
  'DECEMBER'
];

export const VACATION_AVAILABILITY_WEEKDAY_KEYS = [
  'VACATION_WEEKDAY_MONDAY',
  'VACATION_WEEKDAY_TUESDAY',
  'VACATION_WEEKDAY_WEDNESDAY',
  'VACATION_WEEKDAY_THURSDAY',
  'VACATION_WEEKDAY_FRIDAY',
  'VACATION_WEEKDAY_SATURDAY',
  'VACATION_WEEKDAY_SUNDAY'
];



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/vacation/vacation-availability-calendar.constants.ts